import { Link } from "react-router-dom";
import "../Services.css";
import { useState } from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "1. Can a Non-US Resident or Non-US Citizen Incorporate a Business in the USA?",
      answer: (
        <>
          <p>Yes. Non-US residents can form a company in the U.S. You don't need to be a U.S. citizen or have a U.S. address. You'll need a Registered Agent and an EIN (Employer Identification Number) for taxes and banking.</p>
        </>
      )
    },
    {
      question: "2. What Business Structures Can I Choose From?",
      answer: (
        <>
          <p>The two most common structures are LLC (Limited Liability Company) and C-Corporation (C-Corp). LLCs suit small businesses seeking flexibility, while C-Corps are ideal for startups aiming for external investment.</p>
        </>
      )
    },
    {
      question: "3. What is a Registered Agent, and Do I Need One?",
      answer: (
        <>
          <p>A Registered Agent is a mandatory contact for official legal and tax documents. All U.S. LLCs and Corporations must have one in their formation state. BooksComply offers this in all 50 states.</p>
        </>
      )
    },    
    {
      question: "4. What is an EIN and Why Do I Need It?",
      answer: (
        <>
          <p>An EIN (Employer Identification Number) is a tax ID issued by the IRS. You need it to open a bank account, file taxes, and hire employees.</p>
        </>
      )
    }
  ];

  const [openIdx, setOpenIdx] = useState(null);
  const toggle = (idx) => setOpenIdx((prev) => (prev === idx ? null : idx));

  return (
    <div className="faq-section py-5">
      <div className="container">
        {/* FAQ Section Title */}
        <div style={{
          textAlign: 'left',
          marginBottom: '40px',
          padding: '0 20px',
          maxWidth: '1200px',
          margin: '0 auto 40px',
          padding: '0 20px'
        }}>
          <h2 style={{
            fontSize: '2.2rem',
            color: '#0f172a',
            marginBottom: '15px',
            fontWeight: '800',
            lineHeight: '1.2',
            '@media (max-width: 768px)': {
              fontSize: '1.8rem',
              marginBottom: '10px'
            }
          }}>
            USA Company Formation FAQs
          </h2>
          <p style={{
            fontSize: '1.1rem',
            color: '#4b5563',
            maxWidth: '700px',
            margin: '0',
            paddingLeft: '0',
            textAlign: 'left',
            lineHeight: '1.6',
            '@media (max-width: 768px)': {
              fontSize: '1rem',
              paddingLeft: '0'
            }
          }}>
            Get answers to common questions about forming a company in the USA
          </p>
        </div>

        <div className="row">
          <div className="col-md-12">
            <div className="faq-accordion">
              {faqs.map((faq, index) => {
                const isOpen = openIdx === index;
                const isString = typeof faq.answer === 'string';
                return (
                  <div className="faq-item" key={index}>
                    <button
                      type="button"
                      className="faq-toggle"
                      aria-expanded={isOpen}
                      aria-controls={`faq-content-${index}`}
                      onClick={() => toggle(index)}
                    >
                      <h5 className="faq-question m-0">{faq.question}</h5>
                      <span className="faq-icon" aria-hidden>{isOpen ? '−' : '+'}</span>
                    </button>
                    <div
                      id={`faq-content-${index}`}
                      className={`faq-content ${isOpen ? 'open' : ''}`}
                      role="region"
                    >
                      <div className="faq-content-inner">
                        {isString ? (
                          <p className="faq-answer" style={{ whiteSpace: 'pre-line', marginBottom: 0 }}>{faq.answer}</p>
                        ) : (
                          <div className="faq-answer">{faq.answer}</div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;